import React, { useState } from 'react';
import { useSelector as useReduxSelector } from 'react-redux';
import { setAccountBalance } from '../api';
import { useDispatch, useSelector } from 'react-redux';
import { setBalance, incrementBalance, decrementBalance, selectBalance } from '../../store/accountSlice';

const UpdateAccountBalance = () => {
  const dispatch = useDispatch();
  const balance = useSelector(selectBalance);
  const user = useReduxSelector(state => state.user.user);
  const [amount, setAmount] = useState('');

  const handleSet = async () => {
    const value = parseFloat(amount);
    if (!isNaN(value)) {
      dispatch(setBalance(value));
      if (user && user.uid) {
        await setAccountBalance(user.uid, value);
      }
      setAmount('');
    }
  };

  const handleIncrement = () => {
    const value = parseFloat(amount);
    if (!isNaN(value)) {
      dispatch(incrementBalance(value));
      setAmount('');
    }
  };

  const handleDecrement = () => {
    const value = parseFloat(amount);
    if (!isNaN(value)) {
      dispatch(decrementBalance(value));
      setAmount('');
    }
  };

  return (
    <div style={{ marginTop: 24, padding: 16, background: '#fffde7', borderRadius: 8, border: '1px solid #ffe082', maxWidth: 400 }}>
      <h4 style={{ marginBottom: 12, color: '#fbc02d' }}>Update Account Balance</h4>
      <div style={{ marginBottom: 8 }}>
        <input
          type="number"
          value={amount}
          onChange={e => setAmount(e.target.value)}
          placeholder="Enter amount"
          style={{ padding: 8, width: '60%', marginRight: 8, borderRadius: 4, border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={handleSet} style={{ padding: '8px 16px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Set</button>
        {/* <button onClick={handleIncrement} style={{ padding: '8px 16px', background: '#43a047', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Add</button>
        <button onClick={handleDecrement} style={{ padding: '8px 16px', background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Subtract</button> */}
      </div>
      {/* <div style={{ marginTop: 12, color: '#333', fontWeight: 'bold' }}>
        Current Balance: ${balance.toFixed(2)}
      </div> */}
    </div>
  );
};

export default UpdateAccountBalance;
